module.exports = __webpack_public_path__ + "res/ic_arrow_a_z.a2f41b0a6e9afbf569d264fe8cd531ff.png";